module.exports = __webpack_public_path__ + "static/media/6510.76abb3d0.jpg";